"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileDetails = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const app_1 = require("app");
const Tooltip_1 = require("../../../../Shared/Components/Tooltip");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
const ValidForTooltip_1 = require("../../ValidForTooltip/ValidForTooltip");
const ValidFor = ({ validFor, isGlobal, globalTooltipMessage, multipleTooltipMessage, }) => {
    if (validFor && validFor.length <= 1) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(Tooltip_1.default, { content: (0, ValidForTooltip_1.ValidForTooltip)(isGlobal, isGlobal ? globalTooltipMessage : multipleTooltipMessage, validFor), modifiers: tooltipModifiers, isPortalRendering: true, children: (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "info-outline", className: "inline-flex justify-center align-middle p-4xs text-bg-accent-01-primary hover:bg-fill-secondary-hovered rounded-full translate-y-[-0.1em]" }) }));
};
const createDetailsString = ({ details, eventTypes, formattedEndDate, formattedStartDate, location, multipleLabel, validFor, validForLabel, }) => {
    let detailsValue = details;
    if (formattedStartDate) {
        const eventsTypesArray = eventTypes ? eventTypes : [];
        let formattedDate = formattedStartDate;
        if (formattedEndDate && formattedStartDate !== formattedEndDate) {
            formattedDate += ' - ' + formattedEndDate;
        }
        detailsValue = [formattedDate, ...eventsTypesArray, location]
            .filter(x => x != null && x.length > 0)
            .join(', ');
    }
    if (validForLabel && multipleLabel) {
        let tagsDivider = ' | ';
        if (!detailsValue) {
            tagsDivider = '';
        }
        return `${detailsValue || ''}${tagsDivider}${validForLabel}: ${validFor && validFor.length === 1 ? validFor[0] : multipleLabel}`;
    }
    return detailsValue;
};
const tooltipModifiers = [
    {
        name: 'offset',
        options: {
            offset: [14, 6],
        },
    },
];
const TileDetails = ({ isGlobal, globalTooltipMessage, multipleTooltipMessage, formattedStartDate, formattedEndDate, eventTypes, location, validForLabel, validFor, multipleLabel, details, }) => {
    const isDesktopResolution = (0, app_1.isDesktop)();
    const isIPad = app_1.PageService.deviceType === app_1.deviceTypes.iPad;
    const validForComponent = React.useMemo(() => validForLabel &&
        isDesktopResolution &&
        !isIPad && ((0, jsx_runtime_1.jsx)(ValidFor, { globalTooltipMessage: globalTooltipMessage, isGlobal: isGlobal, multipleTooltipMessage: multipleTooltipMessage, validFor: validFor })), [
        globalTooltipMessage,
        isDesktopResolution,
        isGlobal,
        isIPad,
        multipleTooltipMessage,
        validFor,
        validForLabel,
    ]);
    const detailsData = React.useMemo(() => createDetailsString({
        details,
        eventTypes,
        formattedEndDate,
        formattedStartDate,
        location,
        multipleLabel,
        validFor,
        validForLabel,
    }), [
        details,
        eventTypes,
        formattedEndDate,
        formattedStartDate,
        location,
        multipleLabel,
        validFor,
        validForLabel,
    ]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: detailsData && ((0, jsx_runtime_1.jsx)("div", { className: "body-md text-secondary", children: detailsData && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [detailsData, " ", validForComponent] })) })) }));
};
exports.TileDetails = TileDetails;
